import React from 'react';

import styled from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import { mobile, useBreakpoint } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.fitAppMindfulnessBackground};
  display: flex;
  padding: 50px 0 0 0;
  align-items: center;

  ${mobile`
    height: auto;
    flex-direction: column;
  `}
`;

const Content = styled.div`
  flex: 1 0 60%;
  padding: 0 8%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  color: ${({ theme }) => theme.colors.textDefault};
`;

const TextCopy = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: 25px 11px;
  color: ${({ theme }) => theme.colors.fitAppTextCopy};
`;

const StyledAssetContainer = styled(AssetContainer)`
  flex: 1 0 40%;
  display: flex;
  max-height: 634px;

  ${mobile`
    flex-basis: auto;
    height: 443px;
    margin: 30px auto 0 auto;

    * {
      height: 100%;
    }
  `}

  * {
    max-height: 100%;
    width: auto;
  }
`;

export default function FitAppPageMindfulness() {
  const { isMobile } = useBreakpoint();

  return (
    <Wrapper>
      <Content>
        <Title>
          <FormattedMessage
            defaultMessage="Practice Mindfulness"
            id="fitness_app.section_5_title"
          />
        </Title>
        <TextCopy>
          <FormattedMessage
            defaultMessage="Our mental health exercises strengthen your ability to conquer stress and anxiety while helping improve sleep and focus.<br/> New to meditation? Start with our 10-day beginner's series"
            id="fitness_app.section_5_copy"
          />
        </TextCopy>
      </Content>
      <StyledAssetContainer
        name={
          isMobile
            ? 'fitnessapp_content4_mobile'
            : 'fitnessapp_content4_desktop'
        }
      />
    </Wrapper>
  );
}
